<div class="info-page">
  <header class="info-hero">
    <p class="info-kicker">Prize delivery</p>
    <h1 class="info-heading">Shipping Policy</h1>
    <p class="info-sub">How hosts ship prizes, what winners can expect, and who is responsible for delivery.</p>
  </header>

  <div class="info-grid info-grid--two">
    <article class="info-card">
      <p class="info-updated">Last updated: September 18, 2026</p>
      <h2 class="info-block-title"><span class="info-icon info-icon--gold">1</span> Overview</h2>
      <p>LootLucky is a live webinar marketplace. Hosts, not LootLucky, generally ship prizes and other physical goods to winners. This policy applies to hosts and winners and is in addition to our <a routerLink="/TermConditions">Terms &amp; Conditions</a>.</p>
    </article>

    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--teal">2</span> Host shipping duties</h2>
      <p>Unless we state otherwise in writing, the host is responsible for packing, labeling, and shipping the prize to the winner's confirmed address using a reputable carrier.</p>
      <ul>
        <li>Hosts should ship within a reasonable time after the webinar, typically within 10 days subject to availability and any item-specific legal requirements.</li>
        <li>Hosts must provide a valid tracking number in the Host Portal when tracking is available.</li>
        <li>Hosts must comply with all shipping, customs, and product laws, including age, firearms/FFL, and hazardous-goods rules.</li>
      </ul>
    </article>

    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--wine">3</span> Addresses and delays</h2>
      <p>Winners are responsible for keeping a complete, accurate shipping address on file. LootLucky and hosts are not liable for failed delivery caused by an incorrect, incomplete, or outdated address.</p>
      <p>We are not responsible for delays caused by carriers, weather, customs, or other events outside our reasonable control.</p>
    </article>

    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--purple">4</span> Lost, damaged, or restricted items</h2>
      <p>If a tracked package is confirmed lost by the carrier, or an item arrives damaged or materially different from the listing, the winner should contact the host and LootLucky promptly. Hosts should work in good faith to resolve the issue, which may include a replacement or other remedy subject to our <a routerLink="/RefundPolicy">Refund Policy</a> and dispute process.</p>
    </article>

    <article class="info-card info-card--alert">
      <h2 class="info-block-title"><span class="info-icon info-icon--coral">5</span> Costs</h2>
      <p>Shipping costs are determined by the host's listing and selected carrier. Unless the listing says otherwise, shipping charged to buyers or deducted in settlement is non-refundable after a label is purchased or a shipment is handed to the carrier.</p>
    </article>

    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--olive">6</span> Changes and contact</h2>
      <p>We may update this policy from time to time. If this policy conflicts with the Terms &amp; Conditions, the Terms control.</p>
      <a class="info-cta" routerLink="/Contact">Questions about shipping</a>
    </article>
  </div>
</div>
